import UAParser from 'ua-parser-js'
import { TDeviceInfo, TFormFactor } from '../types'
import { getUserAgent } from './getUserAgent'

const _getWebFormFactor = () => {
  const ua = new UAParser(getUserAgent())
  const deviceType = ua.getDevice().type
  // Can be: console, mobile, tablet, smarttv, wearable, embedded
  if (deviceType === 'mobile' || deviceType === 'tablet') {
    return deviceType
  }
  return 'desktop'
}

export const getFormFactor = (baseDeviceInfo: TDeviceInfo): TFormFactor => {
  switch (baseDeviceInfo.platform) {
    case 'tv_xboxone':
      return 'console'
    case 'tv_samsung':
      return 'tv'
    case 'hbbtv':
      return 'tv' // NOTE: no idea if this is correct
    default:
      return _getWebFormFactor()
  }
}
